import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { BaseLocationsSelectSearch } from 'src/components/SelectSearch/BaseLocationsSelectSearch';
import { ILocation } from 'src/types/Location';
import { InsightsLocationsHeader } from 'src/components/common/InsightsLocationsControl/InsightsLocationsHeader';
import { maxAllowedItemsValidation } from 'src/components/SelectSearch/utils/maxAllowedItemsValidation';

const MAX_LOCATIONS_LIMIT = 50;

interface InsightsLocationsControlProps {
  name: string;
}

export function InsightsLocationsControl({
  name,
}: InsightsLocationsControlProps): JSX.Element {
  const { setValue } = useFormContext();
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <BaseLocationsSelectSearch
      name={name}
      corpId={corpId}
      maxSelectedItems={MAX_LOCATIONS_LIMIT}
      maxHeight="410px"
      rules={{
        validate: {
          maxLocations: maxAllowedItemsValidation<ILocation>(
            MAX_LOCATIONS_LIMIT,
            `You have exceeded the max number of ${MAX_LOCATIONS_LIMIT} locations`
          ),
        },
      }}
      onValueChange={(locations: ILocation[] = []): void => {
        setValue(name, locations, { shouldValidate: true, shouldDirty: true });
      }}
      withApplyBtn
      header={<InsightsLocationsHeader maxLocations={MAX_LOCATIONS_LIMIT} />}
      placeholder="Locations"
    />
  );
}
